module.exports = __webpack_public_path__ + "img/business-deal-dark.16a1ac64.svg";